<!-- 账号管理-->
<template>
  <div id="deductMarks" class="deductMarks">
    <el-dialog
      title="扣分详情"
      width="85%"
      top="100px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      show-close
      :before-close="onBack"
      :visible.sync="infoShow"
      append-to-body
    >
      <div class="deductMarks-box">
        <div class="deductMarks-box-info">
          <span>品牌：{{ rankDetail.brandName }}</span>
          <span
            >时间：{{ dayjs(rankDetail.workDate + "").format("YYYY-MM") }}</span
          >
          <span>测评内容：{{ detailTotal.ruleName }}</span>
        </div>
        <div class="deductMarks-table">
          <el-table
            :header-cell-style="{ background: '#FAFAFA', color: '#555' }"
            :data="userData.list"
            style="width: 100%"
          >
            <el-table-column label="序号">
              <template slot-scope="scope">
                {{ (userData.pageNum - 1) * msg.pageSize + 1 + scope.$index }}
              </template>
            </el-table-column>
            <el-table-column label="位置" prop="address" v-if="detailTotal.examineType>0"></el-table-column>
            <el-table-column label="车辆编码" prop="bike_id" v-if="detailTotal.examineType<0"></el-table-column>
            <el-table-column label="违规类型" v-if="detailTotal.examineType==1">
              <template>
                {{ detailTotal.ruleName }}
              </template>
            </el-table-column>
            <el-table-column label="整改时长" v-if="detailTotal.examineType==1">
              <template slot-scope="scope">
                {{ (new Date(scope.row["finishTime"])-new Date(scope.row["createTime"])) |formatTime  }}
              </template>
            </el-table-column>
            <el-table-column label="创建时间" v-if="detailTotal.examineType<2">
              <template slot-scope="scope">
                {{ dayjs(scope.row.create_time||scope.row.rule.create_time).format('YYYY-MM-DD hh:mm:ss') }}
              </template>
            </el-table-column>
            <el-table-column label="扣分" prop="score">
              <template slot-scope="scope">
                <div class="cutMark-color">
                  {{ "-" + scope.row.score }}
                </div>
            </template>
            </el-table-column>
            <el-table-column label="操作"  v-if="detailTotal.examineType>0">
              <template slot-scope="scope">
                <el-button size="text" @click="onShowAdd(scope.row)"
                  >查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column label="上传人" prop="claimUserName" v-if="detailTotal.examineType==1">
            </el-table-column>
          </el-table>
        </div>
        <div class="deductMarks-pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="userData.pageNum"
            :page-size="msg.pageSize"
            layout="total, prev, pager, next"
            :total="userData.total"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <w-dialog
      ref="w-dialog"
      isShowFooter
      :title="miTableBtn.title"
      :width="miTableBtn.dialogWidth"
      @handleClose="onCloseDialog"
      @handleCloseRight="onCloseDialog"
      @onSure="onCloseDialog"
      :isShowCancelBtn="false"
      :isShowSureBtn="false"
    >
      <template v-slot:content>
        <template>
          <template v-for="item in miTableBtn.children">
            <component
              :form.sync="form"
              :is="'v-' + item.component"
              :key="item.key + item.label"
              :params="item"
              :rowData="info"
            >
            </component>
          </template>
        </template>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import WDialog from '@/components/Model/index.vue'
// 纯展示类组件
import vText from '@/views/MiBicycle/components//v-text'
import vImage from '@/views/MiBicycle/components/v-image'
export default {
  components: {
    WDialog,
    vText,
    vImage
  },
  filters: {
    formatTime(msTime) {
      if (!msTime) {
        return '未整改'
      }
      const time = msTime / 1000
      const day = Math.floor(time / 60 / 60 / 24)
      const hour = Math.floor(time / 60 / 60) % 24
      const minute = Math.floor(time / 60) % 60
      const second = Math.floor(time) % 60
      if (day > 0) {
        return `${day}天${hour}时${minute}分${second}秒`
      } else {
        return `${hour}时${minute}分${second}秒`
      }
    }
  },
  name: 'koufen',
  props: {
    infoShow: {
      type: Boolean, // 指定类型
      required: true
    },
    rankDetail: {
      type: Object, // 指定类型
      required: true
    },
    detailTotal: {
      type: Object, // 指定类型
      required: true
    },
    selfAreaId: {
      type: String, // 指定类型
      required: true
    }
  },
  data() {
    return {
      userData: {},
      msg: {
        pageNumber: 1,
        pageSize: 15
      },
      info: {},
      miTableBtn: {},
      miTableBtn1: {
        title: '违规详情',
        dialogWidth: '45%',
        children: [
          // 展示内容明细
          {
            label: '举报位置',
            key: 'address',
            component: 'text',
          },
          {
            label: '举报品牌',
            key: 'brandName',
            component: 'text',
          },
          {
            label: '违规类型',
            key: 'examineInfo.title',
            component: 'text',
          },
          {
            label: '举报状态',
            key: 'status',
            component: 'text',
            filters: 'filterStatus'
          },
          {
            label: '提交人',
            key: 'reportName',
            component: 'text',
          },
          {
            className: 'mb24',
            label: '创建时间',
            key: 'create_time',
            component: 'text',
            filters: 'dateFormat'
          },
          {
            label: '车辆编码',
            key: 'bikeId',
            component: 'text',
          },
          {
            className: 'mb24',
            label: '车牌号',
            key: 'licenseCode',
            component: 'text',
          },
          {
            label: '认领人',
            key: 'claim_user_name',
            component: 'text',
          },
          {
            className: 'mb24',
            label: '认领时间',
            key: 'claim_time',
            component: 'text',
            filters: 'dateFormat'
          },
          {
            label: '照片',
            key: 'miAccuseLogVo',
            component: 'text',
          }
        ]
      },
      miTableBtn2: {
        title: '测评详情',
        dialogWidth: '60%',
        children: [
          {
            label: '地点',
            key: 'address',
            component: 'text'
          },
          {
            label: '扣分',
            key: 'score',
            component: 'text'
          },
          {
            label: '考核内容',
            key: 'title',
            component: 'text'
          },
          {
            label: '现场说明',
            key: 'memo',
            component: 'text'
          },
          {
            label: '考核描述',
            key: 'description',
            component: 'text'
          },
          {
            label: '照片',
            key: 'pictures',
            component: 'image'
          }
        ]
      }
    }
  },
  watch: {
    infoShow() {
      if (this.infoShow) {
        this.onGetList()
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.msg.pageNumber = val
      this.onGetList()
    },
    onShowAdd(data) {
      this.info = data
      const examineJsonObject = JSON.parse(this.info.examineInfo)
      // 考核内容
      this.$set(this.info, 'title', examineJsonObject.title)
      // 考核描述
      this.$set(this.info, 'description', examineJsonObject.description)
      if (data.examine_type == 1) {
        this.miTableBtn = this.miTableBtn1
      } else {
        this.miTableBtn = this.miTableBtn2
      }
      this.$refs['w-dialog'].onShowDialog()
    },
    onCloseDialog() {
      this.$refs['w-dialog'].onCloseDialog()
    },
    onGetList() {
      let param = {
        brandId: this.rankDetail.brandId,
        workDate: this.rankDetail.workDate,
        examineId: this.detailTotal.examineId,
        selfAreaId: this.selfAreaId
      }
      param = { ...param, ...this.msg }
      Api.getRankDetailList(param).then(({ data }) => {
        data.list = data.list.map((val) => {
          val = {
            ...JSON.parse(val.infoBak),
            score: val.score
          }
          if (val.info) {
            val = { ...val, ...val.info }
          }
          return val
        })
        this.userData = data
      })
    },
    // 关闭按钮
    onBack() {
      this.$emit('closepop')
    }
  }
}
</script>
<style scoped lang="less">
#deductMarks {
  width: 100%;
}
.deductMarks {
  &-add {
    width: 100%;
    margin-bottom: 10px;
    .add-right {
      width: 49%;
      float: right;
      text-align: right;
    }
    .add-left {
      width: 49%;
      float: left;
      text-align: left;
    }
  }
  &-pagination {
    margin: 20px 0;
    text-align: right;
  }

  &-box {
    // width: calc(~'100% - 0.4rem');
    width: 100%;
    // height: calc(~'100% - 0.3rem');
    height: 100%;
    // float: left;
    background: #fff;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    &-info {
      color: #999;
      padding-bottom: 20px;
      span {
        margin-right: 20px;
      }
    }
    .cutMark-color {
      color: #f56c6c;
    }
    // .deductMarks-table {
    //     border-top: 3px solid #1890ff;
    // }
  }
  .status1 {
    color: #1890ff !important;
  }
  .status2 {
    color: #f56c6c !important;
  }
  .status3 {
    color: #67c23a !important;
  }
}
</style>
